<div class="dialog-wrapper theme-interface" [ngClass]="customClass">
  <div class="dialog-header" [class.hide-close]="hideCloseButton">
    <div
      class="d-flex justify-content-end close-btn-container"
      *ngIf="!hideCloseButton"
    >
      <button
        type="button"
        class="close-button font-weight-bold theme-color-header"
        data-testid="dialog-close-button"
        (click)="onCloseClick()"
      >
        <span>{{ 'public.global.close' | translate }}</span>
        <app-icon icon="fas fa-times"></app-icon>
      </button>
    </div>

    <h1
      class="dialog-title theme-color-header font-size-popup-title"
      *ngIf="dialogTitle"
    >
      {{ dialogTitle }}
    </h1>
  </div>

  <ng-content></ng-content>
</div>
